<template>
    <v-card :loading="loading" class=" my-0 py-0 grey lighten-4" color="#232323" dark>
        <template slot="progress">
            <v-progress-linear color="teal" indeterminate />
        </template>
        <v-row no-gutters dense align="center" style="background: #232323;">
            <v-col cols="6" align="start" class="pl-3">
                {{ statHeader.text }}
            </v-col>
            <v-col cols="6" align="end">
                Full list
                <v-btn icon @click="$emit('scrollToStats')">
                    <v-icon
                        color="teal"
                        medium
                    >
                        mdi-arrow-right-thin-circle-outline
                    </v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-data-table
            :headers="option ? teamHeaders : playerHeaders"
            :items="stats"
            class=" py-3 font-weight-bold"
            hide-default-footer
            disable-sort
            :mobile-breakpoint="0"
            :items-per-page="-1"
            :item-class="leaderStatClass"
            @click:row="handleClick"
        >
            <template v-slot:item.games="{ item }">
                <v-row dense align="center" height="60px">
                    <v-col cols="12" align="start" class="py-2">
                        {{ item.stats.length }}
                    </v-col>
                </v-row>
            </template>
            <template v-slot:item.avg="{ item }">
                <v-row dense align="center">
                    <v-col cols="12" align="start" class="py-2">
                        {{ item.avg[statHeader.value].toFixed(1) }}
                    </v-col>
                </v-row>
            </template>
            <template v-slot:item.cum="{ item }">
                <v-row dense align="center">
                    <v-col cols="12" align="start" class="py-2">
                        {{ item.cum[statHeader.value] }}
                    </v-col>
                </v-row>
            </template>
            <template v-slot:item.player="{ item }">
                <v-row dense align="center" justify="center">
                    <v-col cols="12" align="start" class="py-2">
                        <img
                            :src="`${assetsUrl}/${item.image}`"
                            height="auto"
                            width="50px"
                            contain
                            class="mr-2"
                            style="display: inline-flex;"
                            @error="$event.target.src = defaultPlayerImg"
                        >
                        <div>{{ `${item.name}` }}</div>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:item.team="{ item }">
                <v-row dense align="center" justify="center">
                    <v-col cols="12" align="start" class="py-2">
                        <v-avatar style="border-radius: 10px; display: inline-flex;" size="50px" color="white">
                            <img :src="`${assetsUrl}/${item.teamLogo}`" height="50px" width="auto">
                        </v-avatar>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:item.name="{ item }">
                <v-row dense align="center" justify="center">
                    <v-col cols="12" align="start" class="py-2">
                        <img
                            :src="`${assetsUrl}/${item.logo}`"
                            height="auto"
                            width="50px"
                            contain
                        >
                    </v-col>
                </v-row>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
    export default {
        props: {
            option: {
                type: Boolean,
                default: true
            },
            stats: {
                type: Array,
                default: null
            },
            statHeader: {
                type: Object,
                default: null
            },
            loading: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                defaultPlayerImg: require('@/assets/default_player.png'),
                assetsUrl: 'https://storage.googleapis.com',
                teamHeaders: [
                    { text: 'Team', value: 'name' },
                    { text: 'Games', value: 'games' },
                    { text: 'Avg', value: 'avg' },
                    { text: 'Total', value: 'cum' }
                ],
                playerHeaders: [
                    { text: 'Player', value: 'player' },
                    { text: 'Team', value: 'team' },
                    { text: 'Games', value: 'games' },
                    { text: 'Avg', value: 'avg' },
                    { text: 'Total', value: 'cum' }
                ]
            }
        },
        watch: {
        },
        methods: {
            leaderStatClass(item) {
                if (this.stats.indexOf(item) === 0) {
                    return 'leader-stat'
                }
            },
            handleClick(row) {
                if (this.option) {
                    this.$router.push({ path: `/Team/${row.id}` })
                } else {
                    this.$router.push({ path: `/Player/${row.id}` })
                }
            }
        }
    }
</script>

<style>

.leader-stat {
    /* background: linear-gradient(90deg, #f05252 0%, #f67c47 50%, rgb(252, 178, 42) 100%) !important; */

    /* color: white; */
    font-weight: 600;
}

</style>
